import { useTheme } from 'next-themes';
import { memo, useCallback } from 'react';

import { MoonIcon, SunIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

const DARK_THEME = 'dark';
const LIGHT_THEME = 'light';
const SWITCH_TO_DARK_MODE_LABEL = 'Switch to dark mode';
const SWITCH_TO_LIGHT_MODE_LABEL = 'Switch to light mode';

export const ToolbarThemeToggle = memo(() => {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === DARK_THEME;
  const themeLabel = isDark ? SWITCH_TO_LIGHT_MODE_LABEL : SWITCH_TO_DARK_MODE_LABEL;

  const handleToggleTheme = useCallback(() => {
    setTheme(isDark ? LIGHT_THEME : DARK_THEME);
  }, [isDark, setTheme]);

  return (
    <Tooltip label={themeLabel}>
      <IconButton
        adsIcon
        appearance="ghost"
        color="gray"
        data-testid="CANVAS_TOOLBAR_THEME_TOGGLE"
        icon={isDark ? SunIcon : MoonIcon}
        label={themeLabel}
        onClick={handleToggleTheme}
      />
    </Tooltip>
  );
});

ToolbarThemeToggle.displayName = 'ToolbarThemeToggle';
